<template>
  <div class="integral">
    <div v-html="vipRule"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    
    
    };
  },
  created() {
    this.$loading.hide();
    var floor = this.$route.params.floor;
    this.vipRule = floor.vipCenterStyle.vipRule; // 规则
  },
  methods: {
   
  }
};
</script>

<style lang="less" scoped>
  .integral {
    // font-size: 32px;
    //  padding: 0 30px 30px 30px;
  }
 
</style>